<script setup lang="ts">
type Props = {
  amountValue: number;
  userCurrency: string;
};

const { amountValue, userCurrency } = defineProps<Props>();

type Emits = {
  setAmountFunction: [number];
};

const emit = defineEmits<Emits>();

const { parameters } = useParameters();
const { showMoneyFormat } = useWallet();

const amountInteger = computed(() => {
  return amountValue / 100;
});

const canShowThisButton = (value: any) => {
  if (value * 100 < (parameters.value?.min_deposit_value || 0)) {
    return false;
  }
  if (value * 100 > (parameters.value?.max_deposit_value || 0)) {
    return false;
  }

  return true;
};

const buttonsValues = computed(() => {
  if (
    userCurrency === 'NGN' ||
    userCurrency === 'ARS' ||
    userCurrency === 'UYU'
  ) {
    return [1000, 2000, 4000, 10000, 20000, 50000];
  }

  if (userCurrency === 'MXN') {
    return [200, 500, 1000, 2500, 5000, 10000];
  }

  if (userCurrency === 'INR') {
    return [100, 200, 400, 1000, 2000, 5000];
  }

  return [20, 50, 100, 250, 500, 1000];
});

const filteredButtons = computed(() => {
  return buttonsValues.value.filter((i) => canShowThisButton(i));
});
</script>

<template>
  <div :class="$style.depositShortcuts">
    <template
      v-for="(button, index) in filteredButtons"
      :key="index + button"
    >
      <div
        :id="`button_${index}`"
        :class="[
          $style.button,
          { [$style.isCurrent]: amountInteger === button },
        ]"
        @click.prevent="emit('setAmountFunction', button)"
      >
        {{ showMoneyFormat({ value: button, withCents: false }) }}

        <span
          v-if="amountInteger === button"
          :class="$style.selectedIcon"
        >
          <NuxtIcon name="check" />
        </span>
      </div>
    </template>
  </div>
</template>

<style module lang="scss">
.depositShortcuts {
  @apply flex items-center justify-center flex-wrap gap-2 relative my-4;

  .button {
    @apply bg-gradient-to-b from-auth-button-deposit-bg/10 to-auth-button-deposit-bg/5 relative overflow-hidden px-2 py-2.5 rounded-lg flex-1 whitespace-nowrap text-auth-button-bg cursor-pointer font-extrabold text-base text-center border border-solid border-auth-button-deposit-bg/5 min-w-[30%];

    &.isCurrent {
      @apply [text-shadow:_0_0_10px_var(--tw-shadow-color)] shadow-primary/50 border-primary bg-gradient-to-br from-auth-button-deposit-bg/20 to-auth-button-deposit-bg/5;
    }

    .selectedIcon {
      @apply absolute -bottom-0 right-0 bg-primary text-black text-[.55rem] uppercase font-bold rounded-tl-lg px-1.5 py-0.5 flex justify-center items-center gap-1;
    }
  }
}
</style>
